<?xml version="1.0" encoding="UTF-8"?>
<svg width="96px" height="93px" viewBox="0 0 96 93" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Artboard</title>
    <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="linearGradient-1">
            <stop stop-color="#FFFFFF" offset="0%"></stop>
            <stop stop-color="#FFFFFF" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="50%" y1="41.129%" x2="50%" y2="66.71%" id="linearGradient-2">
            <stop stop-color="#D90338" offset="0%"></stop>
            <stop stop-color="#0069C4" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-36" transform="translate(3.125000, 3.125000)">
            <polygon id="Path" stroke="#D9DDDF" stroke-width="2.25" fill="url(#linearGradient-1)" fill-rule="nonzero" points="0 0 89.75 0 89.75 85.75 0 85.75"></polygon>
            <line x1="19.875" y1="36.128" x2="69.873" y2="36.622" id="Path" stroke="#D90338" stroke-width="2.5" stroke-linecap="square"></line>
            <line x1="19.875" y1="64.128" x2="69.873" y2="64.622" id="Path" stroke="#006AC8" stroke-width="2.5" stroke-linecap="square"></line>
            <polygon id="Path" fill="url(#linearGradient-2)" fill-rule="nonzero" points="28.875 16.875 59.875 16.875 59.875 67.875 28.875 67.875"></polygon>
        </g>
    </g>
</svg>